<div class="modal-header">
  <h4 class="modal-title" id="modal-basic-title">{{createForm.value.id ? "Update": "Create"}} Locator</h4>
  <button type="button" class="close" aria-label="Close" (click)="close()">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body" id="modal-body">
  <!-- Create/Edit Section -->
  <div class="mt-2">
    <form [formGroup]="createForm" (ngSubmit)="saveLocator()">
      <div class="row">
        <div class="col-3">
          <label for="component-name">Name<span class="text-danger">*</span></label>
          <input type="text" id="component-name" class="form-control form-control-sm" formControlName="name" required />
        </div>
        <div class="col-3">
          <label for="page-label">Select Page Label</label>
          <ng-select *ngIf="!isNewPageLabel" id="page-label" class="required custom-style" formControlName="pageLabel" [items]="pageLabelList" bindLabel="name" placeholder="Select Page Label" [searchable]="true" [clearable]="false">
          </ng-select>
          <input *ngIf="isNewPageLabel" type="text" id="page-label" class="form-control form-control-sm" [(ngModel)]="newPageLabelName" [ngModelOptions]="{standalone: true}" placeholder="Page Label Name" required />
          <input type="checkbox" [(ngModel)]="isNewPageLabel" [ngModelOptions]="{standalone: true}" style="margin-right: 8px;" (click)="pageLabelRequiredValidator(pageLabelControl)" /><span style="font-size: 12px;"><i>New Page Label</i></span>
        </div>
        <div class="col-3">
          <label for="locator-type">Locator Type <span class="text-danger">*</span></label>
          <ng-select class="custom-style" id="locator-type" formControlName="locatorType" [items]="uiMeta.locatorTypes" placeholder="Select" [searchable]="true">
            <ng-option [value]="">Select</ng-option>
          </ng-select>
        </div>
        <div class="col-3">
          <label for="component-type">Component Type <span class="text-danger">*</span></label>
          <ng-select class="custom-style" id="component-type" formControlName="componentType" [items]="uiMeta.componentTypes" placeholder="Select" [searchable]="true" [clearable]="false"></ng-select>
        </div>
        <div class="col-3">
          <label for="locator-path">Path <span class="text-danger">*</span></label>
          <input type="text" id="locator-path" class="form-control form-control-sm" formControlName="locatorString" required />
        </div>
        <div class="col-3" *ngIf="createForm.get('locatorType')?.value === 'BY_ROLE'">
          <label for="role-type">Select Aria Role <span class="text-danger">*</span></label>
          <ng-select class="custom-style" id="role-type" formControlName="ariaRole" [items]="ariaRoleItems" placeholder="Select Role Type" [searchable]="true">
            <ng-option [value]="">Select Role Type</ng-option>
          </ng-select>
        </div>
        
        <div class="col-12 text-right">
          <button type="submit" id="save-locator" class="btn relay-btn relay-createbtn" [ngClass]="createForm.value.id ?'update':'create'" [disabled]="!createForm.valid || (isNewPageLabel && (newPageLabelName === undefined || newPageLabelName === ''))">{{createForm.value.id ? "Update": "Create"}}</button>
          <button type="button" id="cancel-locator" class="btn relay-btn cancel" (click)="cancelCreateForm()" (click)="close()">Cancel</button>
        </div>
      </div>
    </form>
  </div>  
</div>